export enum LeftNavigationIconClass {
  Support = 'fa-regular fa-messages-question',
  Settings = 'fa-regular fa-gear',
  CooperBots = 'fa-regular fa-dog',
  PartnerAndCommunity = 'fa-regular fa-handshake',
  Kaseya365 = 'fa-kit fa-k365',
  OrganizationMapping = 'fa-regular fa-arrow-right-arrow-left',
  AutomationCenter = 'fa-regular fa-plug',
  Dashboard = 'fa-regular fa-grid-2',
  OrganizationDashboard = 'fa-regular fa-chart-mixed',
  SubscriptionsAndBilling = 'fa-regular fa-money-check',
  Learning = 'fa-regular fa-landmark',
  Programs = 'fa-regular fa-calendar-star',
  SetupSummary = 'fa-regular fa-list-check',
  ThirdPartyIdp = 'fa-regular fa-key',
  Security = 'fa-solid fa-shield-halved',
  AccessGroups = 'fa-regular fa-user-group',
  User = 'fa-regular fa-user',
  ModuleUrls = 'fa-regular fa-link-simple',
  CooperInsights = 'fa-regular fa-lightbulb',
  RoleManagement = 'fa-regular fa-clipboard-user',
  PaymentMethods = 'fa-regular fa-credit-card',
  CompareInvoices = 'fa-regular fa-swap-arrows',
  RequestTaxExemption = 'fa-regular fa-receipt',
  Invoices = 'fa-regular fa-file-invoice',
  Subscriptions = 'fa-kit fa-regular-calendar-rotate',
  Orders = 'fa-regular fa-truck',
  Transactions = 'fa-regular fa-clock-rotate-left',
}
